import { IMPORTANT_FILTERS } from '@screens/Category/config/filters';
import { TransformedCategoryFilterItemType } from '@screens/Category/model/types/categoryFilters';

export const getImportantFiltersForCategory = (
  filters: Record<string, TransformedCategoryFilterItemType>,
  categoryKey: string
) => {
  if (!filters || typeof filters !== 'object') {
    console.error('фильтр не является объектом или не существует');
    return {};
  }

  if (!IMPORTANT_FILTERS || !Array.isArray(IMPORTANT_FILTERS[categoryKey])) {
    console.error('ключи фильтров не совпадают с ключами выбранных фильтров');
    return {};
  }

  const result: Record<string, TransformedCategoryFilterItemType> = {};

  IMPORTANT_FILTERS[categoryKey]?.forEach((item) => {
    if (filters[item]) {
      result[item] = filters[item];
    }
  });

  return result;
};
